import { createFileRoute } from '@tanstack/react-router'

import {
  IStepperItem,
  Stepper,
  useStepperController,
} from '@/components/ui/stepper'

export const Route = createFileRoute('/playground/stepper')({
  component: RouteComponent,
})

function RouteComponent() {
  const { stepper, setStepper, registerStep, stepRefs } =
    useStepperController(MOCK_STEPPER)

  return (
    <div className="p-4">
      <Stepper>
        {stepper.map((item) => {
          return (
            <Stepper.Item
              key={item.id}
              item={item}
              ref={registerStep(item.id)}
              onClick={() => {
                alert('hahah')
                setStepper(
                  stepper.map((i) =>
                    i.id === item.id ? { ...i, status: 'focus' } : i
                  )
                )
              }}
            />
          )
        })}
      </Stepper>
    </div>
  )
}

const MOCK_STEPPER: IStepperItem[] = [
  {
    id: '1',
    title: 'Step 1',
    description: 'This is the first step',
    status: 'complete',
  },
  {
    id: '3',
    title: 'Step 3',
    description: 'This is the second step',
    status: 'focus',
  },
  {
    id: '4',
    title: 'Step 4',
    description: 'This is the third step',
    status: 'disable',
  },
]
